import { Icon } from '@iconify/react';
import React from 'react';
import { Link } from 'react-router-dom';
import {
  COMPANY_EMAIL,
  COMPANY_LOCATION,
  COMPANY_PHONES,
} from '../../constants/brand';

export default function ContactInfoWidget() {
  return (
    <ul className="cs_contact_widget">
      <li>
        <Link to="https://maps.com" style={{ display: 'flex', alignItems: 'center' }}>
          <i className="cs_accent_bg">
            <Icon icon="ep:location" />
          </i>
          {COMPANY_LOCATION}
        </Link>
      </li>
      {COMPANY_PHONES.map((phone) => (
        <li key={phone.display}>
          <Link to={phone.tel} style={{ display: 'flex', alignItems: 'center' }}>
            <i className="cs_accent_bg">
              <Icon icon="fluent:call-24-regular" />
            </i>
            {phone.display}
          </Link>
        </li>
      ))}
      <li>
        <Link to={`mailto:${COMPANY_EMAIL}`} style={{ display: 'flex', alignItems: 'center' }}>
          <i className="cs_accent_bg">
            <Icon icon="bi:envelope" />
          </i>
          {COMPANY_EMAIL}
        </Link>
      </li>
    </ul>
  );
}
